import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/useAppSelector";
import { canScanQr, isAdmin } from "../helpers/roles";

/**
 * QR scanner guard (SUPERADMIN | OPERATOR).
 * Redirect priority: isAdmin → /; else → /404 (no loop with AdminRoute).
 */
function QrScannerRoute({ children }) {
  const user = useAppSelector((state) => state.auth.user);
  const rol = user?.rol;

  if (canScanQr(rol)) {
    return children;
  }

  if (isAdmin(rol)) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to="/404" replace />;
}

export { QrScannerRoute };
